import { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputMask } from "primereact/inputmask";
import { Card } from "primereact/card";
import { SelectButton } from "primereact/selectbutton";
import { customerService } from "../../services/CustomerService";
import { Toast } from "primereact/toast";
import { useNavigate } from "react-router-dom";
import CustomerAddressSection from "../../components/CustomerAddressSection";
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

export default function CustomerAddPage() {
    const [mounted, setMounted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    useEffect(() => { setMounted(true); }, []);
  const toast = useRef(null);
  const navigate = useNavigate();
  const [customerType, setCustomerType] = useState(1);
  const [customer, setCustomer] = useState({
    name: "",
    email: "",
    phone: "",
    authorizedPerson: "",
    address: "",
    otherInfo: "",
    taxOffice: "",
    taxNumber: "",
    isTaxExempt: false,
    bankInfo: "",
    fixedDiscountRate: null,
    openingBalance: null,
    customerNumber: 0,
    note: "",
    // Adres bileşeni verileri için alanlar
    provinceId: 0,
    districtId: 0,
    villageId: 0,
  });

  useEffect(() => {
    const fetchNextNumber = async () => {
      try {
        const res = await customerService.getNextNumber();
        setCustomer(prev => ({ ...prev, customerNumber: res.data }));
      } catch (err) {
        console.error("Müşteri numarası alınamadı", err);
      }
    };
    fetchNextNumber();
  }, []);

  
  const typeOptions = [
    { label: 'Bireysel', value: 1, icon: 'pi pi-user' },
    { label: 'Kurumsal', value: 2, icon: 'pi pi-building' }
  ];

  const handleChange = (field, value) => {
    setCustomer(prev => ({ ...prev, [field]: value }));
  };

  const handleAddressChange = (addressData) => {
    setCustomer(prev => ({
      ...prev,
      customerType,
      provinceId: addressData.ilId,
      districtId: addressData.ilceId,
      villageId: addressData.koyId
    }));
  };

  const handleSave = async (confirmed = false) => {
    if (!customer.name) {
      toast.current.show({
        severity: 'warn',
        summary: 'Eksik Bilgi',
        detail: 'Ad Soyad / Şirket Ünvanı alanı zorunludur.',
        life: 3000
      });
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await customerService.create({ ...customer, customerType, confirmed });
      if (response.data.success) {
        toast.current.show({
          severity: 'success',
          summary: 'Başarılı',
          detail: 'Müşteri başarıyla kaydedildi',
          life: 3000
        });
        setTimeout(() => navigate(`/customers`), 1500);
      } else {
        const message = response.data.message;
        if (message.startsWith("DUPLICATE_TAX_NUMBER:")) {
          const taxNumber = message.split(":")[1];
          confirmDialog({
            message: `${taxNumber} kimlik/vergi numaralı müşteri mevcut yine de kaydetmek istiyor musunuz?`,
            header: 'Mükerrer Kayıt Uyarısı',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Evet, Kaydet',
            rejectLabel: 'Vazgeç',
            acceptClassName: 'p-button-danger',
            accept: () => handleSave(true),
            onHide: () => setIsSubmitting(false)
          });
        } else if (message.startsWith("DUPLICATE_PHONE:")) {
          const phone = message.split(":")[1];
          confirmDialog({
            message: `${phone} telefon numaralı müşteri mevcut yine de kaydetmek istiyor musunuz?`,
            header: 'Mükerrer Kayıt Uyarısı',
            icon: 'pi pi-exclamation-triangle',
            acceptLabel: 'Evet, Kaydet',
            rejectLabel: 'Vazgeç',
            acceptClassName: 'p-button-danger',
            accept: () => handleSave(true),
            onHide: () => setIsSubmitting(false)
          });
        } else {
          setIsSubmitting(false);
          toast.current.show({
            severity: 'error',
            summary: 'Hata',
            detail: message || 'Kaydedilirken bir hata oluştu',
            life: 3000
          });
          setIsSubmitting(false);
        }
      }
    } catch (err) {
      console.error(err);
      toast.current.show({
        severity: 'error',
        summary: 'Hata',
        detail: 'Kaydedilirken bir hata oluştu',
        life: 3000
      });
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    navigate(`/customers`);
  };

  return (
    <div className="p-1">
      <Toast ref={toast}  appendTo={mounted ? document.body : "self"} />
      <ConfirmDialog  appendTo={mounted ? document.body : "self"} />
<Card>      {/* Üst Başlık ve Butonlar */}
      <div className="flex flex-col md:flex-row justify-between items-center mb-6 gap-4">
        <div>
          <h2 className="m-0 text-gray-900 font-bold text-2xl flex items-center gap-2">
            <i className="pi pi-user-plus text-blue-600 !text-[1.8rem]"></i>
            Yeni Müşteri Ekle
          </h2>
          <p className="text-gray-600 m-0 mt-1">Sisteme yeni bir müşteri kaydı tanımlayın.</p>
        </div>
        <div className="flex gap-2">
          <Button label="Geri Dön" icon="pi pi-arrow-left" className="p-button-outlined p-button-secondary rounded-lg" onClick={handleCancel} disabled={isSubmitting} />
          <Button label="Kaydet" icon="pi pi-save" className="p-button-success rounded-lg px-4" iconPos="left" onClick={() => handleSave(false)} loading={isSubmitting} />
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* SOL KOLON - GENEL VE İLETİŞİM */}
        <div className="lg:col-span-8">
          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-id-card"></i><span>Genel Bilgiler</span></div>}
            className="shadow-md rounded-xl mb-6 border-t-4 border-blue-600"
          >
            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-4 gap-y-3 p-fluid">
              <div className="md:col-span-2 mb-2">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Müşteri Tipi</label>
                <SelectButton value={customerType} options={typeOptions} onChange={(e) => setCustomerType(e.value || 1)} className="w-fit" />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">{customerType === 1 ? 'Ad Soyad' : 'Şirket Ünvanı'}</label>
                <InputText value={customer.name} onChange={(e) => handleChange("name", e.target.value)} placeholder={customerType === 1 ? 'Örn: Ahmet Yılmaz' : 'Örn: ABC Teknoloji A.Ş.'} />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Müşteri No</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-hashtag"></i></span>
                  <InputNumber value={customer.customerNumber} disabled placeholder="Otomatik" />
                </div>
              </div>

              <div className="mt-1">
                <label className="font-bold text-gray-900 mb-2 block text-sm">E-Mail</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-envelope"></i></span>
                  <InputText value={customer.email} onChange={(e) => handleChange("email", e.target.value)} placeholder="ornek@mail.com" />
                </div>
              </div>

              <div className="mt-1">
                <label className="font-bold text-gray-900 mb-2 block text-sm">Telefon</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon"><i className="pi pi-phone"></i></span>
                  <InputMask value={customer.phone} onChange={(e) => handleChange("phone", e.target.value)} mask="0(999) 999 99 99" placeholder="0(5xx) xxx xx xx" />
                </div>
              </div>
              
              {customerType === 2 && (
                <div className="md:col-span-2 mt-2">
                  <label className="font-bold text-900 mb-2 block text-sm">Yetkili Kişi</label>
                  <InputText value={customer.authorizedPerson} onChange={(e) => handleChange("authorizedPerson", e.target.value)} placeholder="Görüşülen kişi adı" />
                </div>
              )}
            </div>
          </Card>

          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-map-marker"></i><span>Adres ve Notlar</span></div>}
            className="shadow-md rounded-xl mb-6"
          >
            <div className="flex flex-col gap-4 p-fluid">
              <CustomerAddressSection
                value={{ ilId: customer.ilId, ilceId: customer.ilceId, koyId: customer.koyId }}
                onChange={handleAddressChange}
              />
              
              <div>
                <label className="font-bold text-900 mb-2 block text-sm">Açık Adres</label>
                <InputTextarea rows={3} value={customer.address} onChange={(e) => handleChange("address", e.target.value)} autoResize />
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="font-bold text-gray-900 mb-2 block text-sm">Diğer Bilgiler</label>
                  <InputTextarea rows={2} value={customer.otherInfo} onChange={(e) => handleChange("otherInfo", e.target.value)} autoResize />
                </div>
                <div>
                  <label className="font-bold text-gray-900 mb-2 block text-sm">Not</label>
                  <InputTextarea rows={2} value={customer.note} onChange={(e) => handleChange("note", e.target.value)} autoResize />
                </div>
              </div>
            </div>
          </Card>
        </div>

        {/* SAĞ KOLON - CARİ BİLGİLER */}
        <div className="lg:col-span-4">
          <Card
            title={<div className="flex items-center gap-2 text-blue-600 uppercase text-sm font-bold"><i className="pi pi-money-bill"></i><span>Cari / Finans Bilgileri</span></div>}
            className="shadow-md rounded-xl border-t-4 border-blue-600"
          >
            <div className="flex flex-col gap-4 p-fluid">
              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">{customerType === 1 ? 'T.C. Kimlik No' : 'Vergi No'}</label>
                <InputText value={customer.taxNumber} onChange={(e) => handleChange("taxNumber", e.target.value)} maxLength={customerType === 1 ? 11 : 10} />
              </div>

              {customerType === 2 && (
                <div>
                  <label className="font-bold text-gray-900 mb-2 block text-sm">Vergi Dairesi</label>
                  <InputText value={customer.taxOffice} onChange={(e) => handleChange("taxOffice", e.target.value)} />
                </div>
              )}

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Açılış Bakiyesi</label>
                <div className="p-inputgroup">
                  <span className="p-inputgroup-addon">₺</span>
                  <InputNumber value={customer.openingBalance} onValueChange={(e) => handleChange("openingBalance", e.value)} mode="decimal" minFractionDigits={2} maxFractionDigits={2} placeholder="0.00" />
                </div>
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Banka Bilgileri</label>
                <InputTextarea value={customer.bankInfo} onChange={(e) => handleChange("bankInfo", e.target.value)} placeholder="IBAN veya Banka detayları" autoResize />
              </div>

              <div>
                <label className="font-bold text-gray-900 mb-2 block text-sm">Sabit İskonto (%)</label>
                <div className="p-inputgroup">
                  <InputNumber value={customer.fixedDiscountRate} onValueChange={(e) => handleChange("fixedDiscountRate", e.value)} min={0} max={100} placeholder="0" />
                  <span className="p-inputgroup-addon">%</span>
                </div>
              </div>

              <div className="mt-2">
                <div className="flex items-center gap-2 p-3 bg-gray-100 rounded-lg border border-gray-200">
                  <Checkbox inputId="taxExempt" checked={customer.isTaxExempt} onChange={(e) => handleChange("isTaxExempt", e.checked)} />
                  <label htmlFor="taxExempt" className="text-sm font-bold text-gray-700 cursor-pointer">Bu müşteri vergiden muaftır</label>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
      </Card>
    </div>
  );
}